<mat-sidenav-container class="sidenav-container">
    <mat-sidenav #sidenav position="end" [opened]="false" class="sidebar">
        <mat-sidenav-content class="sidenav-content">

            <div class="sidenav-content-header">
                <h2>Transferencia bancaria</h2>
                <button mat-icon-button (click)="sidenav.close()" class="close-icon">
                    <mat-icon>close</mat-icon>
                </button>
            </div>

            <div class="transfer-intro">
                Realizá la transferencia a:
            </div>

            <div class="info-cards">
                <div class="info-card">
                    <div class="info-card-icon alias-icon">
                        <mat-icon>alternate_email</mat-icon>
                    </div>
                    <div class="info-card-content">
                        <div class="info-card-label">Alias</div>
                        <div class="info-card-value">{{alias}}</div>
                    </div>
                    <button mat-icon-button class="copy-btn" (click)="copyToClipboard(alias, 'Alias')">
                        <mat-icon>content_copy</mat-icon>
                    </button>
                </div>

                <div class="info-card">
                    <div class="info-card-icon titular-icon">
                        <mat-icon>person_outline</mat-icon>
                    </div>
                    <div class="info-card-content">
                        <div class="info-card-label">Titular</div>
                        <div class="info-card-value">{{titular}}</div>
                    </div>
                </div>

                <div class="info-card">
                    <div class="info-card-icon cuil-icon">
                        <mat-icon>badge</mat-icon>
                    </div>
                    <div class="info-card-content">
                        <div class="info-card-label">CUIL/CUIT</div>
                        <div class="info-card-value">{{cuilCuit}}</div>
                    </div>
                </div>

                <div class="info-card">
                    <div class="info-card-icon banco-icon">
                        <mat-icon>account_balance</mat-icon>
                    </div>
                    <div class="info-card-content">
                        <div class="info-card-label">Banco</div>
                        <div class="info-card-value">{{banco}}</div>
                    </div>
                </div>
            </div>

            <div class="warning-card">
                <mat-icon class="warning-icon">warning</mat-icon>
                <div class="warning-text">
                    <strong>Importante:</strong><br>
                    La transferencia debe realizarse desde una cuenta a tu nombre.
                </div>
            </div>

            <div class="action-button">
                <button mat-raised-button color="primary" (click)="onTransferDone()">
                    Ya hice la transferencia
                </button>
            </div>

        </mat-sidenav-content>
    </mat-sidenav>
</mat-sidenav-container>
